import { icon } from "./icons";
import type { IconName } from "./icons";

export function element(tag: string, className: string): HTMLElement {
  const el = document.createElement(tag);
  if (className) el.className = className;
  return el;
}

// A button that acts on mousedown, so the editor keeps the focus and the
// selection.
export function button(className: string, onPress: () => void): HTMLButtonElement {
  const el = document.createElement("button");
  el.type = "button";
  el.className = className;
  el.addEventListener("mousedown", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!el.disabled) onPress();
  });
  return el;
}

// This function makes a button of a link or a section: a small box with an
// icon. The title tells what the button does.
export function iconButton(name: IconName, title: string, onPress: () => void): HTMLButtonElement {
  const el = button("card-button", onPress);
  setIcon(el, name, title);
  return el;
}

// Change the icon and the title of an icon button. The DOM changes only when
// the icon changes.
export function setIcon(el: HTMLButtonElement, name: IconName, title: string): void {
  el.title = title;
  if (el.dataset["icon"] === name) return;
  el.dataset["icon"] = name;
  el.replaceChildren(icon(name));
}
